<template>
  <div class="not-found-container">
    <div class="container text-center py-5">
      <div class="row justify-content-center">
        <div class="col-md-6">
          <h1 class="display-1 text-bpb-primary-blue fw-bold">404</h1>
          <h2 class="text-bpb-primary-blue mb-4">Página no encontrada</h2>
          <p class="text-muted mb-4">
            Lo sentimos, la página que buscas no existe o ha sido movida.
          </p>
          <router-link to="/" class="btn btn-lg bpb-button-green-01 rounded-pill px-4 py-2 fw-bold">
            Volver al inicio
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'NotFound',
  mounted() {
    // Establecer el código de estado 404 para SEO
    if (typeof window !== 'undefined' && window.history) {
      document.title = '404 - Página no encontrada | Bien para Bien';
    }
  }
}
</script>

<style scoped lang="scss">
.not-found-container {
  min-height: 70vh;
  display: flex;
  align-items: center;
}
</style>